import { cx } from '@emotion/css';
import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaInfoCircle } from 'react-icons/fa';
import FormControl from 'react-bootstrap/FormControl';
import { useFormikContext } from 'formik';

import { SelectInput } from 'Shared/form/SelectField';
import { dateRelationOptions } from '../constants';
import { isFieldValid } from '../utils';

const propTypes = {
    dateTypeOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const defaultProps = {};

function ActivityDueDate({ dateTypeOptions }) {
    const formik = useFormikContext();

    if (!dateTypeOptions) {
        return null;
    }
    const isDaysValid = isFieldValid('days', formik);
    const isDateRelationValid = isFieldValid('dateRelation', formik);
    const isDateTypeValid = isFieldValid('dateType', formik);

    const hasErrorLabel = R.includes('error', [isDateRelationValid, isDateTypeValid, isDaysValid]);

    return (
        <FormGroup className={cx({ 'has-error': hasErrorLabel })}>
            <div className="label-tooltip-group">
                <FormLabel htmlFor="activity-due-date-days" className="control-label field-required">
                    Activity Due Date
                </FormLabel>

                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="activity-due-date">
                            The Activity Due Date for the new activity that will be triggered
                        </Tooltip>
                    }
                >
                    <FaInfoCircle className="info-icon" />
                </OverlayTrigger>
            </div>

            <div className="activity-due-date-group">
                <FormControl
                    id="activity-due-date-days"
                    min="0"
                    type="number"
                    value={formik.values.days}
                    name="days"
                    className={cx('due-date', { 'has-error': isDaysValid })}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="#"
                />
                <span> days </span>

                <SelectInput
                    name="dateRelation"
                    options={dateRelationOptions}
                    className={cx('before-after', { 'has-error': isDateRelationValid })}
                    value={formik.values.dateRelation}
                    onChange={(option) => {
                        formik.setFieldValue('dateRelation', option);
                    }}
                    onBlur={() => formik.setFieldTouched('dateRelation')}
                />

                <SelectInput
                    name="dateType"
                    options={dateTypeOptions}
                    className={cx('date-type', { 'has-error': isDateTypeValid })}
                    aria-label="Due Date Type"
                    value={formik.values.dateType}
                    onChange={(option) => {
                        formik.setFieldValue('dateType', option);
                    }}
                    onBlur={() => formik.setFieldTouched('dateType', true, false)}
                />
            </div>
        </FormGroup>
    );
}

ActivityDueDate.propTypes = propTypes;
ActivityDueDate.defaultProps = defaultProps;

export default ActivityDueDate;
